import { render, staticRenderFns } from "./CollapsablePanel.vue?vue&type=template&id=4f27ee67&lang=pug&"
import script from "./CollapsablePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsablePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports